
import ExternalConfiguration from '../../external-configuration';

const Constants = {
  Actions: {
    js: 'js',
    config: 'config',
    event: 'event',
  },
  Events: {
    load: 'load',
    play: 'play',
    time: 'time',
    adPlayed: 'adPlayed',
    adClicked: 'adClicked',
  },
};

const Globals = {
  googleScript: null,
  sendOnStartPlaying: false,
  sendOnTime25_100: false,
  sendOnTime50_100: false,
  sendOnTime75_100: false,
  sendOnTime100_100: false,
  sendOnAdPlayed: false,
  sendOnAdClicked: false,
};

const GoogleAnalytics = {

  processConfiguration: (loadedConfiguration, auxiliarData) => {
    if( !loadedConfiguration.googleAnalytics) return null;
    const analyticsConfiguration = {
        gtag: loadedConfiguration.googleAnalytics,
    };

    return analyticsConfiguration;
  },

  onLoad: (analyticsConfiguration) => {
    if( !Globals.googleScript && analyticsConfiguration?.google?.gtag) {
      Globals.googleScript = document.createElement( 'script');
      Globals.googleScript.src = `${ExternalConfiguration.Analytics.google.googletagmanagerBasePath}?id=${analyticsConfiguration.google.gtag}`;
      Globals.googleScript.async = true;
      Globals.googleScript.onload = event => GoogleAnalytics.onSetup( analyticsConfiguration);
      document.head.append( Globals.googleScript );
    }
  },

  onSetup: (analyticsConfiguration) => {
    if( analyticsConfiguration?.google?.gtag) {
      window.dataLayer = window.dataLayer ?? [];
      GoogleAnalytics.onAction( analyticsConfiguration, Constants.Actions.js, new Date());
      GoogleAnalytics.onAction( analyticsConfiguration, Constants.Actions.config, analyticsConfiguration.google.gtag);
      GoogleAnalytics.onEvent( analyticsConfiguration, Constants.Events.load, {
        iframe_name: analyticsConfiguration.iframe?.name,
      });
    }
  },

  onAction: (analyticsConfiguration, action, param, ...data) => {
    (function gtag() {
      window.dataLayer?.push( arguments);
    })( action, param, ...data);
  },

  onEvent: (analyticsConfiguration, event, data) => {
    GoogleAnalytics.onAction( analyticsConfiguration, Constants.Actions.event, event, data);
  },

  onPlay: (analyticsConfiguration) => {
    if( !Globals.sendOnStartPlaying) {
        GoogleAnalytics.onEvent( analyticsConfiguration, Constants.Events.play, {
        iframe_name: analyticsConfiguration.iframe?.name,
      });
      Globals.sendOnStartPlaying = true;
    }
  },

  onTime: (analyticsConfiguration, time, duration) => {
    if( duration) {
      const fraction = time / duration;
      const sendEvent = (percentage) => {
        GoogleAnalytics.onEvent( analyticsConfiguration, Constants.Events.time, {
          iframe_name: analyticsConfiguration.iframe?.name,
          current_time: time, duration, fraction, percentage,
        });
      };
      if( !Globals.sendOnTime25_100 && fraction >= .25 && fraction < .26) { sendEvent( '25 %'); Globals.sendOnTime25_100 = true; }
      if( !Globals.sendOnTime50_100 && fraction >= .50 && fraction < .51) { sendEvent( '50 %'); Globals.sendOnTime50_100 = true; }
      if( !Globals.sendOnTime75_100 && fraction >= .75 && fraction < .76) { sendEvent( '75 %'); Globals.sendOnTime75_100 = true; }
      if( !Globals.sendOnTime100_100 && fraction >= 1) { sendEvent( '100 %'); Globals.sendOnTime100_100 = true; }
    }
  },

  onAdPlayed: (analyticsConfiguration) => {
    if( !Globals.sendOnAdPlayed) {
        GoogleAnalytics.onEvent( analyticsConfiguration, Constants.Events.adPlayed, {
        iframe_name: analyticsConfiguration.iframe?.name,
      });
      Globals.sendOnAdPlayed = true;
    }
  },

  onAdClicked: (analyticsConfiguration) => {
    if( !Globals.sendOnAdClicked) {
        GoogleAnalytics.onEvent( analyticsConfiguration, Constants.Events.adClicked, {
        iframe_name: analyticsConfiguration.iframe?.name,
      });
      Globals.sendOnAdClicked = true;
    }
  },

};

export default GoogleAnalytics;
